import { ResponsiveImage } from './chunk-BI277V2Z.mjs';
import Link from '@mui/material/Link';
import { jsx } from 'react/jsx-runtime';

var Content = () => {
  return /* @__PURE__ */ jsx(
    ResponsiveImage,
    {
      sizes: "40px",
      widths: [40],
      src: "https://res.cloudinary.com/shinabr2/image/upload/v1670251329/Public/Images/sworld-logo-72x72.png",
      alt: "Flow Logo"
    }
  );
};
var Logo = (props) => {
  const { LinkComponent } = props;
  if (LinkComponent) {
    return /* @__PURE__ */ jsx(LinkComponent, { to: "/", children: /* @__PURE__ */ jsx(Content, {}) });
  }
  return /* @__PURE__ */ jsx(Link, { href: "/", children: /* @__PURE__ */ jsx(Content, {}) });
};
var logo_default = Logo;

export { logo_default };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-5QHANN2W.mjs.map